import footerAddresses from '../content/footer-addresses.json'

type FooterAddress = {
  order: number
  country: string
  line1: string
  line2: string
}

const sortByOrder = <T extends { order: number }>(items: T[]): T[] =>
  [...items].sort((a, b) => a.order - b.order)

const addresses = {
  col1: sortByOrder(footerAddresses.addresses as FooterAddress[]),
}

export default addresses
